import useBrand from '@rio-cloud/rio-uikit/useBrand';
import { useLayoutEffect } from 'react';
import { Environment } from '../common/types';

export const useEnvironmentBrand = (environment: Environment) => {
    const { setBrand } = useBrand();

    useLayoutEffect(() => {
        setBrand(environment === Environment.RIO ? 'rio' : 'vw');
    }, [environment, setBrand]);
};
